import { specToString } from 'elements/hardwareSelector/ComponentOverview'
import { HardwareComponentType } from 'elements/hardwareSelectorV2/types'
import _ from 'lodash'
import { styled, Table, TableBody, TableCell, TableRow } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { FC, useMemo } from 'react'

interface PropTypes {
  component: HardwareComponentType
  parsedComponentData?: Record<string, unknown>
}

const TableStyled = styled(Table, { name: 'TableStyled' })(({ theme }) => ({
  margin: '0 50px',
  width: 'unset',
  border: theme.mixins.borderStandard.border,
}))

const TableRowStyled = styled(TableRow, { name: 'TableRowStyled' })(({ theme }) => ({
  '& td:first-child': {
    borderRight: theme.mixins.borderStandard.border,
    color: theme.palette.grey[700],
  },
  '& td:last-child': {
    maxWidth: 380,
    fontWeight: 600,
  },
}))

const TechnicalContent: FC<PropTypes> = ({ component, parsedComponentData = {} }) => {
  const translate = useTranslate()
  const componentData = useMemo(() => {
    // Use parsed data if provided, otherwise parse it (fallback for backwards compatibility)
    const data = parsedComponentData && Object.keys(parsedComponentData).length > 0 
      ? parsedComponentData 
      : (component.data ? JSON.parse(component.data) : {})
    return Object.keys(specToString)
      .filter((fieldKey) => !!_.get(component, fieldKey) || (data && !!_.get(data, fieldKey)))
      .map((fieldKey) => {
        const value = component[fieldKey] || data[fieldKey]
        return {
          name: specToString[fieldKey]?.label,
          value: specToString[fieldKey].valueToString ? specToString[fieldKey].valueToString(value) : value,
        }
      })
      .filter(item => item.value !== null)
  }, [component, parsedComponentData])
  return (
    <TableStyled>
      <TableBody>
        {componentData.map((x) => (
          <TableRowStyled>
            <TableCell>{translate(x.name)}</TableCell>
            <TableCell>{x.value}</TableCell>
          </TableRowStyled>
        ))}
      </TableBody>
    </TableStyled>
  )
}

export default TechnicalContent
